import { Box, IconButton, Typography } from '@mui/material';
import {
  AddMoreButton,
  PaymentSchemeDetailTableHeader,
  PaymentSchemeDetailTableHeaderItem,
  PaymentSchemeInstallmentRowItem,
  PaymentSchemeInstallmentRowWrapper
} from '../../styled';
import pallet from '../../../../layouts/pallet';
import { InstallmentTabContentProps } from '../../types';
import DropdownSelect from '../../../../components/DropdownSelect';
import {
  particularOptions,
  paymentSchemeInstallmentHeader
} from '../../utils/constant';
import TextInputWithIcon from '../../../../components/TextInputWithIcon';
import CustomDatePicker from '../../../../components/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Icons from '../../../../components/icons';
import { isEmpty } from 'lodash';
import { PickerValue } from '@mui/x-date-pickers/internals';

const InstallmentTabContent = ({
  feePeriodOptions,
  installmentsData,
  handleAddInstallmentRow,
  selectedRow,
  onEditRow,
  onDeleteRow,
  onFieldChange
}: InstallmentTabContentProps) => {
  return (
    <>
      <PaymentSchemeDetailTableHeader>
        {paymentSchemeInstallmentHeader.map((title, index) => (
          <PaymentSchemeDetailTableHeaderItem key={index} itemIndex={index}>
            <Typography fontWeight='700' color={pallet.formLabelText}>
              {title}
            </Typography>
          </PaymentSchemeDetailTableHeaderItem>
        ))}
      </PaymentSchemeDetailTableHeader>
      {installmentsData?.map((installment, index) => {
        const isEditable = selectedRow?._id === installment._id;
        return (
          <PaymentSchemeInstallmentRowWrapper key={index}>
            <PaymentSchemeInstallmentRowItem>
              <DropdownSelect
                label=''
                placeholder='Select Fee Period'
                name='feePeriod'
                value={installment.feePeriod}
                onChange={(e) => {
                  const value = e.target.value;
                  onFieldChange(installment, 'feePeriod', value);
                }}
                options={feePeriodOptions}
                disabled={!isEditable}
                sx={{
                  minWidth: '120px !important'
                }}
                hasTopLabel={false}
              />
            </PaymentSchemeInstallmentRowItem>
            <PaymentSchemeInstallmentRowItem>
              <DropdownSelect
                label=''
                placeholder='Select Particulars'
                name='particulars'
                value={installment.particulars}
                onChange={(e) => {
                  const value = e.target.value;
                  onFieldChange(installment, 'particulars', value);
                }}
                options={particularOptions}
                disabled={!isEditable}
                sx={{ minWidth: '120px !important' }}
                hasTopLabel={false}
              />
            </PaymentSchemeInstallmentRowItem>
            <PaymentSchemeInstallmentRowItem>
              <TextInputWithIcon
                name='amount'
                placeholder='Enter Amount'
                type='number'
                value={installment.amount}
                disabled={!isEditable}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, '');
                  onFieldChange(
                    installment,
                    'amount',
                    value === '' ? '' : Number(value)
                  );
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    minWidth: '120px !important',
                    marginTop: '6px'
                  }
                }}
                hasTopLabel={false}
              />
            </PaymentSchemeInstallmentRowItem>
            <PaymentSchemeInstallmentRowItem>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomDatePicker
                  label=''
                  onChange={(value: PickerValue) => {
                    const localValue = value?.add(330, 'minute');
                    onFieldChange(installment, 'paymentDueDate', localValue);
                  }}
                  value={dayjs(installment.paymentDueDate)}
                  formControlMargin='none'
                  disabled={!isEditable}
                  width='156px'
                />
              </LocalizationProvider>
            </PaymentSchemeInstallmentRowItem>
            <Box flex={0.5} sx={{ display: 'flex', justifyContent: 'center' }}>
              <IconButton
                onClick={() => onEditRow(installment)}
                disabled={isEditable}
              >
                <Icons.EditBlackOutlined />
              </IconButton>
            </Box>
            <Box flex={0.5}>
              <IconButton onClick={() => onDeleteRow(installment)}>
                <Icons.Delete />
              </IconButton>
            </Box>
          </PaymentSchemeInstallmentRowWrapper>
        );
      })}

      <AddMoreButton
        onClick={handleAddInstallmentRow}
        sx={{ marginTop: isEmpty(installmentsData) ? '16px' : '4px' }}
      >
        <Icons.PlusPurpleFilled style={{ marginRight: '8px' }} /> Add More
      </AddMoreButton>
    </>
  );
};

export default InstallmentTabContent;
